import axios from 'axios'
import authHeader from "@/service/auth-header";

export default class Icd10CodeService {

  getIcd10Codes() {
    return axios.get('assets/demo/data/icd10codes.json').then(res => res.data.data);
  }

  getIcd10CodesSimple(icd10Code) {
    console.log("[Icd10CodeService][getIcd10CodesSimple] Entering. icd10Code = ", icd10Code );
    return axios.get(`/api/icd10code/simple/${icd10Code}`,{ headers: authHeader() })
  }


}
